/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

// any CSS you import will output into a single css file (app.css in this case)
import './styles/app.scss';
import './js/toast';

window['$'] = require('jquery');
window['bootstrap'] = require('bootstrap');

window.addEventListener("load", () => {
    const flash_closer = document.querySelectorAll("[data-flash-content]");
    flash_closer.forEach(fc => fc.addEventListener("click", () => {
        let content = fc.dataset["flashContent"];
        document.cookie = `${content}=1`;
        fc.parentElement.remove();
    }));
})

new ResizeObserver(entries => {
    let footer = document.querySelector('footer');
    let documentHeight = entries[0].target.clientHeight;
    let windowHeight = window.innerHeight;

    if (footer.classList.contains('fixed-bottom')) {
        documentHeight += footer.clientHeight;
    }
    if (documentHeight > windowHeight) {
        footer.classList.remove('fixed-bottom');
    } else {
        footer.classList.add('fixed-bottom');
    }
}).observe(document.body);